import script from "./IntroTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./IntroTitle.vue?vue&type=script&setup=true&lang=js"

import "./IntroTitle.vue?vue&type=style&index=0&id=5fb1166c&lang=scss"

const __exports__ = script;

export default __exports__